import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import { Box, Stack, Pagination } from '@mui/material'
import ReportCard from './reportCard/ReportCard'
import reportsData from '../../../assets/data/reportData'
import { useLocation } from 'react-router-dom';

function ReportsSection() {

  // const location = useLocation();
  const { inputValue, selectedFilter, setInputValue, setFilterByCategory, filterByCategory } = useContext(ThemeContext);

  // useEffect(() => {
  //   return () => {
  //     if (location.pathname !== '/market_reports') {
  //       // This cleanup function runs when component unmounts (i.e., on route change)
  //       setInputValue(null);
  //       setFilterByCategory(null);
  //     }
  //   };
  // }, [location.pathname]);

  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(reportsData.length / 10);

  const handlePageChange = (_, value) => {
    setPage(value);
    // window.scrollTo({ top: window.scrollY, behavior: 'auto' });
  };


  // Slice data for current page
  // const paginatedData = reportsData.slice(
  //   (page - 1) * 10,
  //   page * 10
  // );



  const filteredReportsData = reportsData.filter(report => {
    const matchesKeyword = inputValue
      ? report.title.toLowerCase().includes(inputValue.toLowerCase())
      : true;

    // const matchesSector = selectedFilter
    //   ? report.sector === selectedFilter
    const matchesCategory = filterByCategory
      ? report.category === filterByCategory
      : true;

    // return matchesKeyword && matchesSector;
    return matchesKeyword && matchesCategory;
  });

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
      {filteredReportsData.map((report, index) => (
        <ReportCard key={index} image={report.image} title={report.title} info={report.info} price={report.price} reportCode={report.reportCode} publishedOn={report.publishDate} category={report.category} pages={report.pages} />
      ))}

      {/* <Pagination count={totalPages} page={page} onChange={handlePageChange}
        sx={{
          '& .Mui-selected': {
            backgroundColor: '#f50057',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#f50057'
            },
          },
          my: 1
        }}
      /> */}
    </Box>
  )
}

export default ReportsSection
